module.exports = __webpack_public_path__ + "static/img/41-2.db41401.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/41-2.jpg
// module id = MTM7
// module chunks = 0